import { Store, select } from '@ngrx/store';

import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

import { News } from '../@models/news.model';
import * as actions from '../@store/news.actions';
import * as reducers from '../@store/news.reducer';

@Injectable()
export class MwNewsDataService {
  constructor(private readonly store: Store<any>) {}

  isNewsReady$: Observable<boolean> = this.store.pipe(
    select(reducers.isNewsReady)
  );
  news$: Observable<News[]> = this.store.pipe(
    select(reducers.isNewsReady),
    filter((isReady) => isReady),
    switchMap(() => this.store.pipe(select(reducers.getNews)))
  );

  refreshNews(): void {
    this.store.dispatch(actions.requestNews({ newsCount: 9 }));
  }

  increaseNewsViewsCounter(): void {
    this.store.dispatch(actions.increaseNewsViewsCounter());
  }
}
